import css from './Details.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'

import { TICKETSMS_COLORS_MEDIUMGREY, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'
import { Dates } from 'utils/dates'

import { useEventData } from 'hooks/useEvent'

interface Props {
  eventId: number
  status: string
}

const SeasonEventDetails: React.FC<Props> = (props) => {
  const { eventId, status } = props

  const { t } = useTranslation()

  const eventData = useEventData({ idOrCodeUrl: String(eventId) })

  if (!eventData) {
    return (
      <div className={classNames(css.eventData, css.skeleton)}>
        <div>
          <Skeleton
            baseColor={TICKETSMS_COLORS_MEDIUMGREY}
            borderRadius={4}
            height={'100%'}
            width={'40%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
        <div>
          <Skeleton
            baseColor={TICKETSMS_COLORS_MEDIUMGREY}
            borderRadius={4}
            height={'100%'}
            width={'60%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
        <div>
          <Skeleton
            baseColor={TICKETSMS_COLORS_MEDIUMGREY}
            borderRadius={4}
            height={'100%'}
            width={'40%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={css.eventData}>
      <div>{`${eventData.name}`}</div>
      <div>{`${Dates.format(new Date(eventData.dateEvent.date_tz), String(t('dates:wallet:dateTickets')))}`}</div>
      <div>{`${String(t(`wallet:status_${status}`))}`}</div>
    </div>
  )
}

export default SeasonEventDetails
